import type { ReactNode } from 'react';

interface SectionTitleProps {
  children: ReactNode;
  /** Optional right-side slot — count badges, action links, etc. */
  trailing?: ReactNode;
  className?: string;
}

/**
 * Small uppercase muted section divider. Matches Welcome page's "Services" /
 * "Ordering" pattern. Use to break long lists into labelled groups.
 */
export default function SectionTitle({ children, trailing, className }: SectionTitleProps) {
  return (
    <div
      className={`section-title-row${className ? ` ${className}` : ''}`}
      style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem', marginTop: '0.5rem' }}
    >
      <h6
        className="section-title flex-grow-1 m-0"
        style={{
          fontSize: '0.75rem',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: 'var(--surface-text-muted, #6b7280)',
        }}
      >
        {children}
      </h6>
      {trailing && <div className="section-title-trailing">{trailing}</div>}
    </div>
  );
}
